import { render, staticRenderFns } from "./RMQ.vue?vue&type=template&id=25773b4a&"
import script from "./RMQ.vue?vue&type=script&lang=js&"
export * from "./RMQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports